import { Injectable } from '@angular/core'
import { DailyLogReactionType } from 'src/app/interfaces/daily-log'
import { DailyLogLogEvent } from 'src/app/interfaces/log/daily-log.log'
import { ReactionInputUIMode } from 'src/app/pages/daily-log/components/daily-log-reaction-input/daily-log-reaction-input.component'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class DailyLogLogService {
  constructor(private logService: LogService) {}

  // [데일리 로그 온보딩] 화면 진입
  logDailyLogOnboardingScreenViewed(type: 'TMI' | 'note' | 'diary') {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_ONBOARDING_SCREEN_VIEWED, { type })
  }

  // [데일리 로그 온보딩] 버튼 클릭
  logDailyLogOnboardingButtonClicked(type: 'static' | 'floating') {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_ONBOARDING_BUTTON_CLICKED, { type })
  }

  // [데일리 로그 온보딩] 공유 클릭
  logDailyLogOnboardingShareButtonClicked(type: 'kakao' | 'qr' | 'x' | 'link') {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_ONBOARDING_SHARE_CLICKED, { type })
  }

  // [로그 디테일] 화면 진입
  logDailyLogDetailScreenViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SCREEN_VIEWED)
  }
  // [로그 디테일] app install top banner 클릭
  logDailyLogDetailAppInstallTopBannerClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_APP_INSTALL_TOP_BANNER_CLICKED)
  }
  // [로그 디테일] Follow 버튼 클릭
  logDailyLogDetailFollowButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_FOLLOW_BUTTON_CLICKED)
  }
  // [로그 디테일] 리액션 입력 클릭
  logDailyLogDetailReactionInputClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_INPUT_CLICKED)
  }
  // [로그 디테일] 추천 스티커 선택
  logDailyLogDetailRecommendStickerSelected(stickerId: number | string) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_RECOMMEND_STICKER_SELECTED, { stickerId })
  }
  // [로그 디테일] 리액션 정렬 버튼 클릭
  logDailyLogDetailReactionSortButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_SORT_BUTTON_CLICKED)
  }

  // [로그 디테일] 내 스티커 스토리 만들기 배너 클릭
  logDailyLogDetailMakeStickerStoryBannerClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_MAKE_STICKER_STORY_BANNER_CLICKED)
  }
  // [로그 디테일 리액션] 옵션 클릭
  logDailyLogDetailReactionOptionClicked(type: DailyLogReactionType | 'TEMPLATE') {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_OPTION_CLICKED, { type })
  }
  // [로그 디테일 리액션] 리액션 아이템 클릭
  logDailyLogDetailReactionReactionItemClicked(type: DailyLogReactionType) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_REACTION_ITEM_CLICKED, { type })
  }
  // [로그 디테일 리액션] 리액션 삭제 버튼 클릭
  logDailyLogDetailReactionDeleteButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_DELETE_BUTTON_CLICKED)
  }
  //[로그 디테일 리액션] 다음 버튼 클릭
  logDailyLogDetailReactionNextButtonClicked(type?: DailyLogReactionType) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_NEXT_BUTTON_CLICKED, { type })
  }
  // [로그 디테일 리액션] 완료 버튼 클릭
  logDailyLogDetailReactionSubmitButtonClicked(type: DailyLogReactionType) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_SUBMIT_BUTTON_CLICKED, { type })
  }
  // [로그 디테일 리액션] 이름 입력 모달 노출
  logDailyLogDetailReactionNameInputModalViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_VIEWED)
  }
  // [로그 디테일 리액션] 이름 입력 모달 닫기 버튼 클릭
  logDailyLogDetailReactionNameInputModalCloseButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_CLOSE_BUTTON_CLICKED)
  }
  // [로그 디테일 리액션] 이름 입력 모달 완료 버튼 클릭
  logDailyLogDetailReactionNameInputModalSubmitButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_SUBMIT_BUTTON_CLICKED)
  }
  // [로그 디테일] 스티커 키보드 toggle 버튼 클릭
  logDailyLogDetailStickerKeyboardToggleButtonClicked(uiMode: ReactionInputUIMode) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_STICKER_KEYBOARD_TOGGLE_BUTTON_CLICKED, { uiMode })
  }
  // [로그 디테일] 공유 UI 노출
  logDailyLogDetailShareUIImpressed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SHARE_UI_IMPRESSED)
  }
  // [로그 디테일] 복사 버튼 클릭
  logDailyLogDetailShareCopyButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SHARE_COPY_BUTTON_CLICKED)
  }
  // [로그 디테일] 로그인 버튼 클릭
  logDailyLogDetailLoginButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_LOGIN_BUTTON_CLICKED)
  }
  // [로그 디테일] 예시 배너 노출
  logDailyLogDetailExampleBannerImpressed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_EXAMPLE_BANNER_IMPRESSED)
  }
  // [로그 디테일] 예시 배너 클릭
  logDailyLogDetailExampleBannerClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_EXAMPLE_BANNER_CLICKED)
  }
  // [로그 디테일] 나도 만들러 가기 노출
  logDailyLogDetailCreateTemplateButtonViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_CREATE_TEMPLATE_BUTTON_VIEWED)
  }
  // [로그 디테일] 나도 만들러 가기 클릭
  logDailyLogDetailCreateTemplateButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_CREATE_TEMPLATE_BUTTON_CLICKED)
  }
  // [로그 디테일] 스티커(리액션) 클릭
  logDailyLogDetailReactionClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_CLICKED)
  }
  // [로그 템플릿] 화면 진입
  logDailyLogTemplateScreenViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_SCREEN_VIEWED)
  }
  // [로그 템플릿] 템플릿 클릭
  logDailyLogTemplateTemplateClicked(templateId: number, isLoggedIn: boolean) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_TEMPLATE_CLICKED, { templateId, isLoggedIn })
  }
  // [로그 템플릿] 템플릿 로그인 모달 노출
  logDailyLogTemplateTemplateLoginModalViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_LOGIN_MODAL_VIEWED)
  }
  // [로그 템플릿] 템플릿 로그인 모달 - 로그인 버튼 클릭
  logDailyLogTemplateTemplateLoginModalLoginButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_LOGIN_MODAL_LOGIN_BUTTON_CLICKED)
  }
  // [로그 템플릿] 템플릿 로그인 모달 - 익명 버튼 클릭
  logDailyLogTemplateTemplateLoginModalAnonymousButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_LOGIN_MODAL_ANONYMOUS_BUTTON_CLICKED)
  }
  // [로그 템플릿] 이름 입력 모달 노출
  logDailyLogTemplateTemplateNameInputModalViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_NAME_INPUT_MODAL_VIEWED)
  }
  // [로그 템플릿] 이름 입력 모달 - submit 클릭
  logDailyLogTemplateTemplateNameInputModalSubmitButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_NAME_INPUT_MODAL_SUBMIT_BUTTON_CLICKED)
  }

  // [로그 템플릿] 예시 배너 클릭
  logDailyLogTemplateExampleBannerClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_EXAMPLE_BANNER_CLICKED)
  }
  // [로그 디테일] 나만 보기 버튼 노출 (웹 only)
  logDailyLogDetailReactionPrivateToggleButtonViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_REACTION_PRIVATE_TOGGLE_BUTTON_VIEWED)
  }
  // [로그 템플릿] 튜토리얼 종료 (웹 only)
  logDailyLogTemplateTutorialFinished(isCanceled: boolean) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_TEMPLATE_TUTORIAL_FINISHED, { isCanceled })
  }
  // [로그 디테일] 튜토리얼 종료
  logDailyLogDetailTutorialFinished(step: string) {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_TUTORIAL_FINISHED, { step })
  }
  //로그 디테일 공유 모달 노출
  logDailyLogDetailShareModalViewed() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SHARE_MODAL_VIEWED)
  }
  //로그 디테일 공유 모달 복사 클릭
  logDailyLogDetailShareModalCopyButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SHARE_MODAL_COPY_BUTTON_CLICKED)
  }
  //로그 디테일 공유 모달 공유 버튼 클릭
  logDailyLogDetailShareModalShareButtonClicked() {
    this.logService.eventLogging(DailyLogLogEvent.DAILY_LOG_DETAIL_SHARE_MODAL_SHARE_BUTTON_CLICKED)
  }
}
